<template>
  <BaseLayout>
    <div class="row">
      <div class="col-xl-12">
        <div class="kt-portlet">
          <div class="kt-portlet__body">
            <div class="kt-form kt-form--label-right kt-margin-t-20 kt-margin-b-10">
              <div class="row align-items-center">
                <div class="col-xl-8 order-2 order-xl-1">
                  <div class="row align-items-center">
                    <div class="col-md-4 kt-margin-b-20-tablet-and-mobile">
                      <div class="kt-input-icon kt-input-icon--left">
                        <input type="text" class="form-control" placeholder="Search..." id="generalSearch" v-model="keyword"/>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                          <span><i class="la la-search"></i></span>
                        </span>
                      </div>
                    </div>

                    <div class="col-md-4 kt-margin-b-20-tablet-and-mobile">
                      <div class="kt-form__group kt-form__group--inline">
                        <div class="kt-form__label">
                          <label>Status:</label>
                        </div>
                        <div class="kt-form__control">
                          <select
                            v-model="selectedStatus"
                            class="form-control bootstrap-select"
                            id="kt_form_status"
                          >
                            <option value>All</option>
                            <option
                              v-for="status in orderTypes"
                              :key="status"
                              :value="status"
                            >
                              {{ orderStatus(status) }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-portlet__body kt-portlet__body--fit mt-4">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th style="width: 20%">Name</th>
                    <th>Arrival Date</th>
                    <th>Due On</th>
                    <th>Service</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in paginateOrders.data" :key="order.id">
                    <th>{{ order.id }}</th>
                    <td><a href="#" @click.prevent="openOrder(order.id)">{{ order.title }}</a></td>
                    <td>
                      <template v-if="order.created_at">
                        {{ durationFromNow(order.created_at) }}
                      </template>
                    </td>
                    <td>
                      <template v-if="order.due_at">
                        {{ durationFromNow(order.due_at) }}
                      </template>
                    </td>
                    <td>{{ order.service.title }}</td>
                    <td>
                      <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--bold" :class="orderStatusClass(order.status)">
                        {{ orderStatus(order.status) }}
                      </span>
                    </td>
                    <td>
                      <DownloadOrderResultFiles
                        v-if="isComplete(order)"
                        :order="order"
                        btn-class="btn btn-outline-brand btn-icon btn-sm mr-2"
                      >
                        <i class="flaticon2-download"></i>
                      </DownloadOrderResultFiles>

                      <button type="button" class="btn btn-outline-brand btn-icon btn-sm" @click.prevent="openOrder(order.id)">
                        <i class="flaticon2-list-2"></i>
                      </button>
                      <button type="button" class="btn  p-1 btn-sm ml-1" style="height: 2.5rem;"  @click.prevent="openOrder(order.id)">
                        <i class="flaticon2-chat"></i> <span class="badge badge-danger">{{order.messages_count}}</span>
                      </button>

                      <button
                        type="button"
                        class="btn p-1 btn-sm ml-1"
                        style="height: 2.5rem"
                        v-if="isDraft(order) || isPending(order)"
                        @click.prevent="editOrder(order)"
                      >
                        <i class="flaticon-edit"></i> Edit
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="kt-portlet__foot">
              <pagination
                :data="paginateOrders"
                @pagination-change-page="getResults"
                align="center"
                :show-disabled="true"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import axios from 'axios';
import BaseLayout from '@/layouts/BaseLayout.vue';
import OrderStatusMixin from "@/mixins/orderStatus.js";
import EditOrderMenuMixin from "@/mixins/EditOrderMenu.js";
import DateTimeMixin from "@/mixins/DateTime.js";
import DownloadOrderResultFiles from "@/components/DownloadOrderResultFiles.vue";

export default {
  name: 'Home',
  components: {
    BaseLayout,
    DownloadOrderResultFiles,
  },
  mixins: [OrderStatusMixin, EditOrderMenuMixin, DateTimeMixin],
  data() {
    return {
      paginateOrders: {},
      keyword: '',
      selectedStatus: "",
    };
  },
  mounted() {
    this.getResults();
  },
  watch: {
    keyword() {
      this.getResults();
    },
    selectedStatus() {
      this.getResults();
    },
  },
  methods: {
    getResults(page = 1) {
      axios
        .get('orders', {
          params: {
            keyword: this.keyword,
            status: this.selectedStatus,
            page: page,
          },
        })
        .then((response) => {
          this.paginateOrders = response.data;
        });
    },
    openMessage(orderId) {
      this.$router.push({
        name: 'message',
        params: { id: orderId },
      });
    },
    openOrder(orderId) {
      this.$router.push({
        name: 'order-details',
        params: { id: orderId },
      });
    },
  },
};
</script>

<style scoped>
select.form-control {
  padding: 0.65rem 1rem !important;
  border: 1px solid #e2e5ec !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
</style>
